import RoadmapIcon from "@/assets/roadmap.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const RoadmapLogo = (props: Props) => (
  <LogoImage imgSrc={RoadmapIcon} alt="Roadmap Logo" size="navbar" {...props} />
);
